import { BaseTariffPage } from "@/components/tarif/BaseTariffPage";
import { Shield, AlertCircle, CheckCircle2, Clock, Phone, FileText, Stethoscope, Users, Building2, Hospital } from "lucide-react";

const RV_COLOR = "#001957";

const RvTarif = () => {
  const faqs = [
    {
      question: "Warum ist R+V für medizinische Praxen geeignet?",
      answer: "R+V ist als eine der größten Versicherungsgruppen Deutschlands ein verlässlicher Partner mit umfassender Erfahrung. Die CyberRisk Versicherung bietet speziellen Schutz für medizinische Einrichtungen mit flexiblen Lösungen und starkem Service."
    },
    {
      question: "Welche Deckungssummen bietet R+V?",
      answer: "R+V bietet flexible Deckungssummen von 250.000 € bis 5.000.000 €. Für kleine Praxen empfehlen wir 500.000 - 1.000.000 €, für größere Einrichtungen 2-5 Mio. €."
    },
    {
      question: "Sind Ransomware-Angriffe versichert?",
      answer: "Ja, Ransomware-Angriffe sind vollumfänglich versichert - inkl. Lösegeldzahlungen (nach Prüfung), IT-Forensik, Datenwiederherstellung und Betriebsunterbrechungskosten."
    },
    {
      question: "Wie schnell reagiert R+V im Schadensfall?",
      answer: "Die 24/7-Cyber-Assistance-Hotline ist sofort erreichbar. Erste Maßnahmen werden innerhalb weniger Stunden eingeleitet. Die Schadensregulierung erfolgt nach Prüfung typischerweise innerhalb von 2-4 Wochen."
    },
    {
      question: "Gibt es eine Wartezeit nach Vertragsabschluss?",
      answer: "Nein, der Versicherungsschutz beginnt sofort nach Vertragsbeginn ohne Wartezeit. Bereits ab dem ersten Tag sind Sie vollständig geschützt."
    },
    {
      question: "Was kostet die R+V Cyberversicherung?",
      answer: "Die Kosten hängen von mehreren Faktoren ab: Praxisgröße, gewünschte Deckungssumme, Selbstbehalt und IT-Sicherheitsmaßnahmen. Kleine Praxen starten bereits ab ca. 350 € pro Jahr. Gerne erstellen wir Ihnen ein individuelles Angebot."
    },
    {
      question: "Welche Cyber-Risiken sind konkret versichert?",
      answer: "Versichert sind u.a.: Ransomware-Angriffe, Phishing, Datenlecks, DSGVO-Verstöße, CEO-Fraud, DDoS-Attacken, Betriebsunterbrechung, IT-Forensik, Rechtskosten und Krisenkommunikation."
    }
  ];

  const insuranceConditions = [
    {
      icon: Shield,
      title: "Selbstbehalt",
      description: "Standardselbstbehalt: 2.500 € pro Schadensfall. Reduzierbar auf 1.000 € oder 500 € gegen Mehrbeitrag. Entfällt bei reinen Assistance-Leistungen."
    },
    {
      icon: CheckCircle2,
      title: "Deckungssummen",
      description: "Flexibel wählbar: 250.000 € bis 5.000.000 €. Empfohlen für Einzelpraxen: 500.000 - 1.000.000 €. Empfohlen für MVZ/Kliniken: 2.000.000 € - 5.000.000 €."
    },
    {
      icon: Phone,
      title: "Service & Support",
      description: "24/7 Cyber-Assistance-Hotline rund um die Uhr erreichbar. Persönlicher Ansprechpartner. Schnelle Schadensregulierung innerhalb von 2-4 Wochen."
    },
    {
      icon: Clock,
      title: "Vertragslaufzeit",
      description: "Mindestlaufzeit: 1 Jahr mit automatischer Verlängerung. Kündigungsfrist: 3 Monate zum Vertragsende. Sonderkündigungsrecht nach Schadensfall."
    },
    {
      icon: FileText,
      title: "Kündigungsfrist",
      description: "3 Monate zum Ende der Vertragslaufzeit. Bei Nichtkündigung automatische Verlängerung um ein weiteres Jahr. Sonderkündigungsrecht nach jedem regulierten Schadensfall."
    },
    {
      icon: AlertCircle,
      title: "24/7 Hotline",
      description: "Keine Wartezeit - Versicherungsschutz ab dem ersten Tag. Cyber-Assistance-Hotline rund um die Uhr erreichbar, auch an Wochenenden und Feiertagen."
    }
  ];

  const documents = [
    {
      title: "R+V CyberRisk Produktinformation",
      type: "PDF, ca. 800 KB",
      url: "/erstinformation.pdf"
    },
    {
      title: "Versicherungsbedingungen (AVB)",
      type: "PDF, ca. 1,2 MB",
      url: "/erstinformation.pdf"
    }
  ];

  const coverageAreas = [
    {
      icon: Shield,
      title: "Eigenschäden",
      items: [
        "Datenwiederherstellung nach Cyberangriff",
        "IT-Forensik und Schadensanalyse",
        "Betriebsunterbrechung & Umsatzausfall",
        "Wiederherstellung von Hard- & Software",
        "Kosten für Krisenmanagement"
      ]
    },
    {
      icon: AlertCircle,
      title: "Cyber-Haftpflicht",
      items: [
        "DSGVO-Bußgelder und Schadensersatz",
        "Datenschutzverletzungen & Meldepflichten",
        "Ansprüche Dritter bei Datenlecks",
        "Abwehr unberechtigter Ansprüche",
        "Rechtsschutz bei Cyber-Vorfällen"
      ]
    },
    {
      icon: Phone,
      title: "24/7 Assistance",
      items: [
        "Cyber-Assistance-Hotline rund um die Uhr",
        "Sofortige Expertenunterstützung",
        "Koordination aller Dienstleister",
        "PR- und Krisenkommunikation",
        "Psychologische Erstbetreuung"
      ]
    },
    {
      icon: CheckCircle2,
      title: "Prävention & Beratung",
      items: [
        "Präventionsberatung zu IT-Sicherheit",
        "Unterstützung bei Security-Maßnahmen",
        "Informationen zu aktuellen Bedrohungen",
        "Checklisten für mehr Cyber-Sicherheit",
        "Persönlicher Ansprechpartner"
      ]
    }
  ];

  const targetGroups = [
    {
      icon: Stethoscope,
      title: "Hausarztpraxen",
      description: "Kleinere Praxen mit hoher Patientenfrequenz und sensiblen Gesundheitsdaten",
      benefits: [
        "Absicherung bei Ransomware-Angriffen auf Praxissoftware",
        "Schutz vor Phishing-Attacken auf Mitarbeiter",
        "24/7-Hotline für schnelle Hilfe im Notfall",
        "Deckung von Betriebsunterbrechungskosten"
      ],
      recommendation: "Empfohlene Deckung: 500.000 - 1.000.000 €"
    },
    {
      icon: Users,
      title: "Facharztpraxen",
      description: "Spezialisierte Praxen mit umfangreichen digitalen Diagnosesystemen",
      benefits: [
        "Schutz teurer medizinischer Geräte mit IT-Komponenten",
        "Absicherung bei Ausfall bildgebender Systeme",
        "DSGVO-Schutz bei Datenübermittlung an Labore",
        "Betriebsunterbrechungsdeckung bei längeren Ausfällen"
      ],
      recommendation: "Empfohlene Deckung: 1.000.000 - 2.000.000 €"
    },
    {
      icon: Building2,
      title: "MVZ & Praxisgemeinschaften",
      description: "Mehrere Ärzte und Standorte mit vernetzten IT-Systemen",
      benefits: [
        "Schutz aller Standorte unter einem Vertrag",
        "Absicherung komplexer IT-Infrastrukturen",
        "Höhere Deckungssummen für größere Schäden",
        "Spezialisierte Beratung für größere Einrichtungen"
      ],
      recommendation: "Empfohlene Deckung: 2.000.000 - 5.000.000 €"
    },
    {
      icon: Hospital,
      title: "Kliniken & Krankenhäuser",
      description: "Große medizinische Einrichtungen mit kritischer IT-Infrastruktur",
      benefits: [
        "Maximalschutz für kritische Systeme",
        "Sofortige Krisenintervention bei Großschäden",
        "Deckung von Massenpatientendaten",
        "Spezialisten für Healthcare-Cyberrisiken"
      ],
      recommendation: "Empfohlene Deckung: 3.000.000 - 5.000.000 €"
    }
  ];

  const heroFeatures = [
    { icon: Phone, title: "24/7 Assistance", subtitle: "Sofort erreichbar" },
    { icon: CheckCircle2, title: "Umfassender Schutz", subtitle: "Alle Risiken abgedeckt" },
    { icon: Shield, title: "Bis 5 Mio. €", subtitle: "Deckungssumme" }
  ];

  return (
    <BaseTariffPage
      companyName="R+V"
      companyColor={RV_COLOR}
      productRating={{ value: 4.8, count: 487 }}
      priceRange="60-215"
      pageTitle="R+V Cyberversicherung für Ärzte & Praxen 2025"
      metaDescription="R+V CyberRisk Versicherung mit 24/7 Assistance-Hotline & schneller Schadensregulierung. Verlässlicher Partner für medizinische Einrichtungen. Jetzt beraten lassen!"
      metaKeywords="R+V Cyberversicherung, Cyber-Versicherung Ärzte, Arztpraxis Cyberschutz, R+V CyberRisk"
      canonicalUrl="https://praxis-versichert.de/tarifwissen/ruv"
      heroLabel="Eine der größten Versicherungsgruppen Deutschlands"
      heroTitle="R+V Cyberversicherung für medizinische Praxen"
      heroDescription="Umfassender Cyber-Schutz mit 24/7-Assistance-Hotline und persönlicher Betreuung. Als eine der größten Versicherungsgruppen Deutschlands bietet R+V verlässlichen Schutz vor Cyber-Risiken für Arztpraxen, MVZ und Kliniken."
      heroFeatures={heroFeatures}
      alertTitle="Warum R+V?"
      alertDescription="Als eine der größten Versicherungsgruppen Deutschlands bietet R+V verlässlichen Cyber-Schutz mit starkem Service-Netzwerk. Mit 24/7-Assistance-Hotline, schneller Schadensregulierung und umfassenden Leistungen sind Sie optimal gegen Cyber-Risiken abgesichert. Über 67% der deutschen KMU wurden 2024 Opfer von Cyber-Angriffen - sind Sie vorbereitet?"
      coverageAreas={coverageAreas}
      targetGroups={targetGroups}
      insuranceConditions={insuranceConditions}
      faqs={faqs}
      documents={documents}
    />
  );
};

export default RvTarif;
